import { render, staticRenderFns } from "@/clickbuy/purchase/views/shopping-cart/shopping-cart.pug?vue&type=template&id=46dcc800&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/clickbuy/purchase/views/shopping-cart/shopping-cart.scss?vue&type=style&index=0&id=46dcc800&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcc800",
  null
  
)

export default component.exports